import React from 'react'
import ReactDOM from 'react-dom'
import App from './App'
import serverData, { init as initServerData } from './utils/server-data'
import { ContextProvider as WorldReadyContextProvider } from '@paypalcorp/worldready-react'
import reportWebVitals from './utils/reportWebVitals'

initServerData()
let root = document.getElementById('root')

if (!root) {
  root = document.createElement('div')
  document.body.appendChild(root)
}

ReactDOM.render(
  <WorldReadyContextProvider locale={serverData.locality.locale}>
    <App path="*" />
  </WorldReadyContextProvider>,
  root,
)

reportWebVitals()
